var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{directives:[{name:"input-focus",rawName:"v-input-focus"}],attrs:{"disabled":_vm.disabled,"fetch-suggestions":function (qs, cb) {
      _vm.queryAPI({ name: qs }, cb);
    },"debounce":0,"placeholder":_vm.placeholder,"popper-class":"cm-port-list-popper-class","value":_vm.value},on:{"change":function (e) {
      _vm.$emit('change', e);
    },"select":function (e) {
      _vm.$emit('select', e);
    },"input":function (e) {
      _vm.$emit('input', e);
    }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var item = ref.item;
return [_c('AutoPortTemplate',{attrs:{"detail":item,"showCountryFlag":false}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }